'use client';

import React, { useState } from 'react';

import twMerge from 'utilities/src/twMerge';

import FAQAccordion from './FAQAccordion';
import type { FAQProps } from './_props';

/**
 * Component
 */

export default function FAQ({
  title,
  questions,
  className,
  titleClassName = '',
  questionsClassName = '',
}: FAQProps) {
  const [openedQuestion, setOpenedQuestion] = useState(0);

  return (
    <section data-testid="collapse-faq-arrow-circle" className={twMerge('flex flex-col gap-10', className)}>
      <h2 className={twMerge('site-display-m font-medium text-black', titleClassName)}>{title}</h2>

      <ul className={twMerge(questionsClassName)}>
        {questions.map((r, index) => (
          <FAQAccordion
            key={r.question}
            question={r.question}
            answer={r.answer}
            index={index}
            openedIndex={openedQuestion}
            setOpenedIndex={setOpenedQuestion}
          />
        ))}
      </ul>
    </section>
  );
}

export type { FAQProps };
